"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.householdsNotOwnedByUser = exports.householdOwnedByUser = exports.household = exports.getHasPendingInvite = exports.getIsUser = exports.selectedMemberPersonId = exports.selectedMemberPerson = exports.getSelectedMember = exports.householdsLoaded = exports.getHouseholds = exports.households = void 0;
exports.organizer = organizer;
exports.findHousehold = findHousehold;
exports.findPerson = findPerson;
exports.tempDeleteHouseholdPerson = tempDeleteHouseholdPerson;
exports.addHouseholdPerson = addHouseholdPerson;
const lodash_1 = require("lodash");
const households = (state) => state.households;
exports.households = households;
const getHouseholds = (state) => (0, exports.households)(state).households;
exports.getHouseholds = getHouseholds;
const householdsLoaded = (state) => (0, exports.households)(state).householdsLoaded;
exports.householdsLoaded = householdsLoaded;
const getSelectedMember = (state) => (0, exports.households)(state).selectedMember;
exports.getSelectedMember = getSelectedMember;
const selectedMemberPerson = (state) => (0, exports.getSelectedMember)(state).person;
exports.selectedMemberPerson = selectedMemberPerson;
const selectedMemberPersonId = (state) => (0, exports.getSelectedMember)(state).personId;
exports.selectedMemberPersonId = selectedMemberPersonId;
const getIsUser = (householdPerson) => !!householdPerson.person.userId;
exports.getIsUser = getIsUser;
const getHasPendingInvite = (householdPerson) => householdPerson.inviteStatus === 'pending';
exports.getHasPendingInvite = getHasPendingInvite;
function organizer(household) {
    const householdOrganizer = (0, lodash_1.find)(household.householdPeople, (p) => p.isOrganizer);
    return householdOrganizer && householdOrganizer.person;
}
const household = (state, currentProfileUuid) => (0, lodash_1.find)((0, exports.getHouseholds)(state), (h) => organizer(h).uuid === currentProfileUuid);
exports.household = household;
const householdOwnedByUser = (state, currentProfileUuid) => (0, lodash_1.find)((0, exports.getHouseholds)(state), (h) => organizer(h).uuid === currentProfileUuid);
exports.householdOwnedByUser = householdOwnedByUser;
const householdsNotOwnedByUser = (state, currentProfileUuid) => (0, lodash_1.filter)((0, exports.getHouseholds)(state), (h) => organizer(h).uuid !== currentProfileUuid);
exports.householdsNotOwnedByUser = householdsNotOwnedByUser;
function findHousehold(households, householdId) {
    return (0, lodash_1.find)(households, (h) => h.id === householdId);
}
function findPerson(household, personId) {
    return (0, lodash_1.find)(household.householdPeople, (hp) => hp.personId === personId);
}
function tempDeleteHouseholdPerson(household, householdPerson) {
    const filteredPeople = (0, lodash_1.filter)(household.householdPeople, (hp) => hp.id !== householdPerson.id);
    household.householdPeople = filteredPeople;
    return filteredPeople;
}
function addHouseholdPerson(household, householdPerson) {
    household.householdPeople.push(householdPerson);
    return householdPerson;
}
